//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { AutomaticDispatchResult } from '../../graphql/entities';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { useDispatchPrintModals } from '../../components/ActionButtons/dispatch/useDispatchPrintModals';
import { WorkspaceActionButtons } from '../../components/Workspace/WorkspaceActionButtons';
import { useDispatchPrintButtons } from '../../components/ActionButtons/dispatch/useDispatchPrintButtons';
import { Direction, IAutomaticDispatchResult, IDispatchInstruction } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';

const AutomaticDispatchResultActionButtonsHOC = (props) => {
  const [{ setLabelModalState, setDeliveryNoteModalState, setConformityCertificateModalState }, printModals] =
    useDispatchPrintModals({ multiValue: true, normalizeResults: true });

  const printButtons = useDispatchPrintButtons(
    {
      setLabelModalState,
      setDeliveryNoteModalState,
      setConformityCertificateModalState,
    },
    {
      actionEntityMapper: (actionEntities: Array<IAutomaticDispatchResult>) =>
        actionEntities.map((value) => value.dispatchInstruction as IDispatchInstruction),
    }
  );

  return (
    <>
      {printModals}
      <WorkspaceActionButtons {...props} actionButtons={printButtons} />
    </>
  );
};

const AutomaticDispatchResultWorkspace = (props) => {
  const fieldNames: Array<Paths<IAutomaticDispatchResult>> = [
    'dispatchInstruction.documentReference',
    'message',
    'success',
  ];

  const workspaceProps = useWorkspace<IAutomaticDispatchResult>(props, AutomaticDispatchResult, {
    columns: fieldNames,
    initialSortColumn: 'createdAt',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={AutomaticDispatchResult.type}
      title={AutomaticDispatchResult.title}
      formUrl={AutomaticDispatchResult.formUrl}
      defaultQuery={AutomaticDispatchResult.workspace}
      {...workspaceProps}
      {...props}
      entity={AutomaticDispatchResult}
      workspaceActionButtonsHOC={AutomaticDispatchResultActionButtonsHOC}
    />
  );
};

export default AutomaticDispatchResultWorkspace;
